import Api from "../config/api";

export const configuracaoHorarioAtendimentoVigente = ({ profissionalSaudeId, dataInicial, dataFinal }) => {
  return Api.post('', {
    query: `
      query ($searchDTO: SearchDTOInput) {
        configuracaoHorarioAtendimentoVigente(searchDTO: $searchDTO) {
          id
          dataInicioVigencia
          dataFimVigencia
        }
      }
    `,
    variables: {
      searchDTO: {
        profissionalSaudeId,
        dataInicial,
        dataFinal
      }
    }
  });
};

export const configuracaoHorarioAtendimentoVigenteOutrosProfissionaisSaude = ({ 
  profissionalSaudeId, 
  unidadeId,
  dataInicial,
  dataFinal
}) => {
  return Api.post('', {
    query: `
      query($searchDTO: SearchDTOInput) {
        configuracaoHorarioAtendimentoVigenteOutrosProfissionaisSaude(searchDTO: $searchDTO) {
          id
          dataInicioVigencia,
          dataFimVigencia,
          duracao
        }
      }
    `,
    variables: {
      searchDTO: {
        profissionalSaudeId, 
        unidadeId,
        dataInicial,
        dataFinal
      }
    }
  });
};

export const findEspacosLivresDoProfissionalSaude = ({
  profissionalSaudeId,
  horaInicio,
  horaFim,
  data
}) => {
  return Api.post('', {
    query: `
      query($profissionalSaudeId: Long, $horaInicio: LocalTime, $horaFim: LocalTime, $data: LocalDate) {
        findEspacosLivresDoProfissionalSaude(
          profissionalSaudeId: $profissionalSaudeId,
          horaInicio: $horaInicio,
          horaFim: $horaFim,
          data: $data
        )
      }
    `,
    variables: {
      profissionalSaudeId,
      horaInicio,
      horaFim,
      data
    }
  });
};

export const findByIdConfiguracaoHorarioAtendimento = async ({ id }) => {
  const response = await Api.post('', {
    query: `
      query($id: Long) {
        findByIdConfiguracaoHorarioAtendimento(id: $id) {
          id
          duracao
          horaInicioPeriodoAtendimento
          horaFimPeriodoAtendimento
          sala {
            id
          }
          horariosAtendimento {
            diaSemana
            horaFim
            horaInicio
            procedimentos {
              id
              nome
            }
            permiteAgendamento
            permiteAgendamentoOnline
            solicitante {
              id
              nome
            }
            convenios {
              id
              descricao
            }
          }
        }
      }
    `,
    variables: {
      id,
    },
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.findByIdConfiguracaoHorarioAtendimento;
};

export const findByIdConfiguracaoHorarioAtendimentoAgendamentoOnline = async ({ id }) => {
  const response = await Api.post('', {
    query: `
      query($id: Long) {
        findByIdConfiguracaoHorarioAtendimento(id: $id) {
          id
          duracao
          horaInicioPeriodoAtendimento
          horaFimPeriodoAtendimento
          horariosAtendimento {
            diaSemana
            horaFim
            horaInicio
            permiteAgendamento
            permiteAgendamentoOnline
            convenios {
              id
              descricao
            }
          }
        }
      }
    `,
    variables: {
      id,
    },
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.findByIdConfiguracaoHorarioAtendimento;
};

export const updateProcedimentosConfiguracaoHorarioAtendimento = async (configuracaoHorarioAtendimento) => {
  const response = await Api.post('', {
    query: `
      mutation ($configuracaoHorarioAtendimento: ConfiguracaoHorarioAtendimentoInput) {
        updateProcedimentosConfiguracaoHorarioAtendimento(configuracaoHorarioAtendimento: $configuracaoHorarioAtendimento) {
          id
        }
      }
    `,
    variables: {
      configuracaoHorarioAtendimento
    },
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.updateProcedimentosConfiguracaoHorarioAtendimento;
};

export const findAllConfiguracaoHorarioAtendimentoSala = async(variables) => {
  const response = await Api.post('', {
    query: `
      query ($searchDTO: SearchConfiguracaoHorarioAtendimentoDTOInput, $pageableDTO: PageableDTOInput) {
        findAllConfiguracaoHorarioAtendimentoSala(searchDTO: $searchDTO, pageableDTO: $pageableDTO) {
          last
          numberOfElements
          content {
            id
            dataInicioVigencia
            dataFimVigencia
            horaInicioPeriodoAtendimento
            horaFimPeriodoAtendimento
            duracao
          }
        }
      }
    `,
    variables: variables,
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.findAllConfiguracaoHorarioAtendimentoSala;
};

export const findAllConfiguracaoHorarioAtendimento = async(variables) => {
  const response = await Api.post('', {
    query: `
      query ($searchDTO: SearchDTOInput) {
        findAllConfiguracaoHorarioAtendimento(searchDTO: $searchDTO) {
          last
          numberOfElements
          content {
            id
            dataInicioVigencia
            dataFimVigencia
            horaInicioPeriodoAtendimento
            horaFimPeriodoAtendimento
            duracao
          }
        }
      }
    `,
    variables: variables,
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.findAllConfiguracaoHorarioAtendimento;
};

export const findAllConfiguracaoHorarioAtendimentoOutrosProfissionaisSaude = async(variables) => {
  const response = await Api.post('', {
    query: `
      query ($searchDTO: SearchDTOInput) {
        findAllConfiguracaoHorarioAtendimentoOutrosProfissionaisSaude(searchDTO: $searchDTO) {
          last
          numberOfElements
          content {
            id
            dataInicioVigencia
            dataFimVigencia
            horaInicioPeriodoAtendimento
            horaFimPeriodoAtendimento
            duracao
          }
        }
      }
    `,
    variables: variables,
  });

  if (response.data.errors) {
    throw response.data.errors[0];
  }

  return response.data.data.findAllConfiguracaoHorarioAtendimentoOutrosProfissionaisSaude;
};
